// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"Competitions_inputSearch__8XrVs"};